import React, { memo } from 'react';
import SizeAndCapacityButton from './SizeAndCapacityButton';
import { useMediaQuery } from 'react-responsive';
import { Breakpoints } from '@settings';
import Icon from '@components/tailwind/Icon';

const SizeAndCapacitySectionSelection = ({ selectors, textOnly = false, activeIdx, setActiveIdx }) => {
  const isMobView = useMediaQuery({ maxWidth: Breakpoints.LG });
  const onClickHandler = (idx: number) => () => setActiveIdx(idx);

  if (isMobView && !textOnly)
    return (
      <>
        <div className='tw:mt-12 tw:flex tw:flex-col tw:items-center'>
          <input
            type='range'
            name='size-capacity'
            id='size-capacity'
            min={0}
            max={selectors.length - 1}
            step={1}
            value={activeIdx}
            className='size-capacity-range-input tw:mx-auto tw:h-[5px] tw:w-[290px] tw:cursor-pointer tw:appearance-none tw:rounded-full tw:border-0 tw:bg-[#F4F4F4] tw:shadow-inner'
            onChange={(e) => setActiveIdx(parseInt(e.target.value))}
          />
        </div>

        <div className='tw:mx-auto tw:flex tw:max-w-[340px] tw:items-center tw:justify-between'>
          {selectors.map((s, idx) =>
            !!s.title.icon ? (
              <Icon
                key={idx}
                url={s.title.icon}
                color='#555'
                hoverColor='#171717'
                isActive={idx === activeIdx}
                size={32}
                className='tw:mb-10 tw:mt-3 tw:cursor-pointer'
                onClick={onClickHandler(idx)}
              />
            ) : (
              <div className='tw:py-4'> {typeof s.title == 'string' ? s.title : s.title.text}</div>
            )
          )}
        </div>
      </>
    );

  return (
    <div className='tw:flex tw:items-center tw:justify-center'>
      <div className='tw:inline-flex tw:flex-wrap tw:justify-center tw:gap-2 tw:rounded-button tw:bg-white tw:p-3'>
        {[...selectors].map((s, idx) => (
          <SizeAndCapacityButton key={idx} isActive={activeIdx === idx} onClick={onClickHandler(idx)}>
            {typeof s.title == 'string' ? s.title : s.title.text}
          </SizeAndCapacityButton>
        ))}
      </div>
    </div>
  );
};

export default memo(SizeAndCapacitySectionSelection);
